import {DisplayContext as DateRangeDisplayContext} from '../../date-range-picker/models/types';
import CohortsPropertyFilter from './cohorts-property-filter';
import CustomEventPropertyFilter from './custom-event-property-filter';
import DefaultPropertyFilter from './default-property-filter';
import PropertyFilter from './property-filter';
import {DisplayContext} from './types';

export {STRING_TYPECAST_PROPERTIES} from './../../../report/constants';

export function createPropertyFilter(
  attributes: Partial<PropertyFilter>,
  {displayContext}: {displayContext: DisplayContext},
): PropertyFilter {
  const PropertyFilterClass = {
    [DisplayContext.Cohorts]: CohortsPropertyFilter,
    [DisplayContext.CustomEvent]: CustomEventPropertyFilter,
    [DisplayContext.Default]: DefaultPropertyFilter,
    [DisplayContext.Insights]: DefaultPropertyFilter,
    [DisplayContext.Signal]: PropertyFilter,
  }[displayContext];
  return new PropertyFilterClass(attributes);
}

export const DATE_RANGE_DISPLAY_CONTEXT_MAP: {[k in DisplayContext]: DateRangeDisplayContext} = {
  [DisplayContext.Cohorts]: DateRangeDisplayContext.Default,
  [DisplayContext.CustomEvent]: DateRangeDisplayContext.PropertyFilter,
  [DisplayContext.Insights]: DateRangeDisplayContext.PropertyFilter,
  [DisplayContext.Default]: DateRangeDisplayContext.PropertyFilter,
  [DisplayContext.Signal]: DateRangeDisplayContext.Default,
};

export default class PropertyFilterFactory {
  public static createPropertyFilter(
    attributes: Partial<PropertyFilter>,
    {displayContext}: {displayContext: DisplayContext},
  ): PropertyFilter {
    return createPropertyFilter(attributes, {displayContext});
  }
}
